
(() => {
    if (window.ajaxCartLoaded) return;
    window.ajaxCartLoaded = true;

    /* ---------- helpers ---------- */
    const getCart = () => fetch('/cart.js').then(r => r.json());

    const updateCartCounter = total => {
        const wrap = document.getElementById('CartCount');
        if (!wrap) return;
        wrap.querySelector('span:first-child').textContent = total;
        const lbl = wrap.querySelector('.icon__fallback-text');
        if (lbl) lbl.textContent = total === 1 ? 'item' : 'items';
        wrap.style.display = total ? '' : 'none';
    };

    const ajaxAdd = body =>
        fetch('/cart/add.js', {
            method : 'POST',
            headers: {'Content-Type':'application/json','Accept':'application/json'},
            body   : JSON.stringify(body)
        }).then(r => { if (!r.ok) throw Error('add failed'); return r.json(); });

    const changeLine = (line, quantity) =>
            fetch('/cart/change.js', {
                    method : 'POST',
                headers: {'Content-Type':'application/json','Accept':'application/json'},
            body   : JSON.stringify({ line, quantity })
       });

            const ajaxChange = (key, quantity) =>
            fetch('/cart/change.js', {
                    method : 'POST',
                headers: {'Content-Type':'application/json','Accept':'application/json'},
            body   : JSON.stringify({ id: key, quantity })
        });

    (() => {
        /* fetch */
        const origFetch = window.fetch;
        window.fetch = async (...args) => {
            const res = await origFetch(...args);
            if (/\/cart\/(add|change|update)\.js|\/cart\.js/.test(args[0])) enforceSingleBundle();
            return res;
        };

        const send = XMLHttpRequest.prototype.send;
        XMLHttpRequest.prototype.send = function (body) {
            this.addEventListener('load', () => {
                if (this.responseURL && /\/cart\/(add|change|update)\.js|\/cart\.js/.test(this.responseURL))
                    enforceSingleBundle();
            });
            return send.call(this, body);
        };
    })();

    const refreshSlideCart = (open = true) =>
        window.SLIDECART_UPDATE &&
        window.SLIDECART_UPDATE(() => open && window.SLIDECART_OPEN && window.SLIDECART_OPEN());

    function applyCartToQtySelectors(cart) {
        document.querySelectorAll('.product-qty-selector').forEach(sel => {
            const input       = sel.querySelector('.qty-input');
            const variantId   = +sel.dataset.variantId;
            const sellingPlan = sel.dataset.sellingPlanId ? +sel.dataset.sellingPlanId : null;
            const subType     = sel.dataset.subscriptionType || null;

            const item = cart.items.find(it => {
                if (it.variant_id !== variantId) return false;
                if (sellingPlan) {
                    const planId = it.selling_plan_allocation?.selling_plan?.id || null;
                    if (planId !== sellingPlan) return false;
                }
                if (subType && it.properties?.subscription_type !== subType) return false;
                return true;
            });

            if (item) {
                input.value = item.quantity;
                sel.dataset.lineKey = item.key;
            } else {
                input.value = 0;
                delete sel.dataset.lineKey;
            }
        });

        updateCartCounter(cart.item_count);
    }

    async function syncBlockQty(block) {
        const input       = block.querySelector('.qty-input');
        const qty         = Math.max(0, Math.min(999, +input.value || 0));

        const variantId   = +block.dataset.variantId;
        const sellingPlan = block.dataset.sellingPlanId ? +block.dataset.sellingPlanId : null;
        const props       = block.dataset.subscriptionType
            ? { subscription_type: block.dataset.subscriptionType } : null;

        let key           = block.dataset.lineKey;

        if (!key && qty === 0) return;

        try {
            if (key) {
                await ajaxChange(key, qty);
                if (!qty) delete block.dataset.lineKey;
            } else if (qty) {
                const item = await ajaxAdd({
                    id: variantId,
                    quantity: qty,
                    ...(sellingPlan && { selling_plan: sellingPlan }),
                    ...(props       && { properties  : props })
                });
                block.dataset.lineKey = item.key;
            }

            refreshSlideCart(true);
            const cart = await getCart();
            applyCartToQtySelectors(cart);
            document.dispatchEvent(new CustomEvent('cart:updated'));
        } catch (err) { console.error(err); }
    }

    document.addEventListener('keydown', e => {
        if (e.target.classList?.contains('qty-input') && e.key === 'Enter') {
            e.preventDefault();
            e.target.blur();
        }
    });

    function scheduleSync(block) {
        clearTimeout(block.syncTimer);
        block.syncTimer = setTimeout(() => syncBlockQty(block), 500);
    }

    document.addEventListener('click', e => {
        const btn = e.target.closest('.qty-btn');
        if (!btn) return;

        const block = btn.closest('.product-qty-selector');
        const input = block.querySelector('.qty-input');

        if (btn.classList.contains('plus'))  input.value = +input.value + 1;
        if (btn.classList.contains('minus')) input.value = Math.max(0, +input.value - 1);

        scheduleSync(block);
    });

    document.addEventListener('change', e => {
        const input = e.target.closest('.qty-input');
        if (!input) return;
        scheduleSync(input.closest('.product-qty-selector'));
    });

    document.addEventListener('click', async e => {
        const btn = e.target.closest('.ajax-add-to-cart');
        if (!btn) return;

        btn.disabled = true;
        try {
            const vId   = +btn.dataset.variantId;
            const spId  = btn.dataset.sellingPlanId ? +btn.dataset.sellingPlanId : null;
            const props = btn.dataset.subscriptionType ? { subscription_type: btn.dataset.subscriptionType } : null;

            await ajaxAdd({ id: vId, quantity: 1, ...(spId && { selling_plan: spId }), ...(props && { properties: props }) });
            refreshSlideCart(true);
            const cart = await getCart();
            applyCartToQtySelectors(cart);
            document.dispatchEvent(new CustomEvent('cart:updated'));
        } catch (err) { console.error(err); }
        finally     { btn.disabled = false; }
    });

    window.SLIDECART_UPDATED = cart => applyCartToQtySelectors(cart);


    let bundleGuardRunning = false;
    const tagCache = new Map();

    async function enforceSingleBundle() {
        if (bundleGuardRunning) return;
        bundleGuardRunning = true;

        try {
            const cart = await getCart();
            const bundles = [];

            for (const [idx, it] of cart.items.entries()) {
                let tags = tagCache.get(it.handle);
                if (!tags) {
                    const resp = await fetch(`/products/${it.handle}.js`);
                    if (!resp.ok) continue;
                    const product = await resp.json();
                    tags = Array.isArray(product.tags) ? product.tags : [];
                    tagCache.set(it.handle, tags);
                }
                if (tags.some(t => t.toLowerCase() === 'b2b bundle')) {
                    bundles.push({ line: idx + 1, qty: it.quantity });
                }
            }

            if (!bundles.length) return;

            const jobs = [];

            if (!window.isB2B) {
                     bundles.forEach(b => jobs.push(changeLine(b.line, 0)));
            } else {
                if (bundles[0].qty !== 1) jobs.push(changeLine(bundles[0].line, 1));
                      bundles.slice(1).forEach(b => jobs.push(changeLine(b.line, 0)));
            }

            if (jobs.length) {
                await Promise.all(jobs);
                const fresh = await getCart();
                applyCartToQtySelectors(fresh);
                refreshSlideCart(false);
            }
        } catch (e) { console.error('Bundle-guard:', e); }
        finally     { bundleGuardRunning = false; }
    }

    document.addEventListener('DOMContentLoaded', enforceSingleBundle);

    document.addEventListener('cart:updated', enforceSingleBundle);

    getCart().then(applyCartToQtySelectors);

    (async () => {
          if (window.isB2B) return;
         const cart = await getCart();
           for (const [i, it] of cart.items.entries()) {
                   const p = await fetch(`/products/${it.handle}.js`).then(r => r.json());
               if (p.tags.includes('B2B Bundle')) await changeLine(i + 1, 0);
               }
            const fresh = await getCart();
              applyCartToQtySelectors(fresh);
              refreshSlideCart(false);
          })();

    document.addEventListener('change', async e => {
        const select = e.target.closest('.b2b-variant-select');
        if (!select) return;

        const itemCard   = select.closest('.product-item');
        const rrpspan    = itemCard.querySelector('.rrp-price');
        const priceSpan  = itemCard.querySelector('.b2b-price');
        const qtyBlock   = itemCard.querySelector('.product-qty-selector');
        const addButton  = itemCard.querySelector('.ajax-add-to-cart');
        const stockSpan  = itemCard.querySelector('.b2b-stock');

        const opt        = select.options[select.selectedIndex];
        const moneyFmt   = select.dataset.moneyFormat || window.theme?.moneyFormat || '${{amount}}';

        const format = cents => {
            cents = parseInt(cents, 10);

            if (window.Shopify && typeof Shopify.formatMoney === 'function') {
                return Shopify.formatMoney(cents, moneyFmt);
            }

            if (window.theme?.Currency?.formatMoney) {
                return theme.Currency.formatMoney(cents, moneyFmt);
            }

            const raw   = (cents / 100).toFixed(2);
            const sym   = moneyFmt.replace(/.*\{\{.*\}\}/, '').trim() || '₴';
            return `${sym}${raw}`;
        };

        if (rrpspan && opt.dataset.rrp)  rrpspan.textContent  = `RRP: ${format(opt.dataset.rrp)}`;
        if (priceSpan)                   priceSpan.innerHTML  = `Your price: ${format(opt.dataset.price)}`;

        const available = opt.dataset.available === 'true';
        if (stockSpan) {
            stockSpan.textContent = available ? '' : 'Sold Out';
        }

        if (!available) {
            qtyBlock.classList.add('is-disabled');
            qtyBlock.querySelector('.qty-input').value = 0;
            addButton?.setAttribute('disabled', 'disabled');
            priceSpan.classList.add('is-disabled')
        } else {
            qtyBlock.classList.remove('is-disabled');
            priceSpan.classList.remove('is-disabled')
            addButton?.removeAttribute('disabled');
        }

        qtyBlock.dataset.variantId = opt.value;
        if (opt.dataset.sellingPlan) qtyBlock.dataset.sellingPlanId = opt.dataset.sellingPlan;
        else                         delete qtyBlock.dataset.sellingPlanId;

        if (addButton) {
            addButton.dataset.variantId = opt.value;
            if (opt.dataset.sellingPlan) addButton.dataset.sellingPlanId = opt.dataset.sellingPlan;
            else                         addButton.removeAttribute('data-selling-plan-id');
        }

        delete qtyBlock.dataset.lineKey;

        try {
            const cart = await getCart();
            applyCartToQtySelectors(cart);
        } catch (err) { console.error(err); }
    });

    function syncVariantSelect(select, forceDefault = false) {
        console.log(forceDefault)
        if (forceDefault) {
            const defOpt = select.querySelector('option[selected]');
            console.log(defOpt)
            setTimeout(() => {
                if (defOpt) select.value = defOpt.value;
            },1000)

        }
        select.dispatchEvent(new Event('change', { bubbles: true }));
    }

    document.addEventListener('DOMContentLoaded', () => {
        document.querySelectorAll('.b2b-variant-select').forEach(sel =>
            syncVariantSelect(sel, true)
        );
    });

    window.addEventListener('pageshow', e => {
        if (!e.persisted) return;
        document.querySelectorAll('.b2b-variant-select').forEach(sel =>
            syncVariantSelect(sel, true)
        );
    });

})();
